/*
*###############################################################################
*Module Name                   : DetComponents.js                              #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Monday, November 8th 2021, 4:09:45 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"
import DPTextBoxforgrid from "../../../../framework/components/DPTextBoxforgrid"
import DPSearchBox from "framework/components/DPSearchBox"
import DPAlert from "../../../../framework/widgets/DPAlert"
import DPSwitch from 'framework/components/DPSwitch'
import DPDropDown from "framework/components/DPDropDown"
import { Text, Numeric } from "../../../../framework/validators/TextValidation" // Textbox input validations


export const TXTDetColumn = ({
    r,
    Key
}) => {
    const [desc, setdesc] = useState("")
    return (
        <td style={{ width: parseInt(r.strColWidth) }}>
            <Row className="mb-3">
                <Col md="12">
                    <DPTextBoxforgrid
                        rowClass="mb-12-sm"
                        labelText="Code"
                        textType="text"
                        maxLength={r.strColLen}
                        id={r.strColTblName + Key}
                        value={desc}
                        disabled={false}
                        onChange={e => {
                            setdesc(e.target.value)
                        }}
                    /*onKeyPress={e => {
                        KeyPressEvnt(e)
                    }}*/
                    ></DPTextBoxforgrid>
                </Col>
            </Row>
        </td >
    );
}
export const DBLDetColumn = ({
    r,
    Key
}) => {
    const [desc, setdesc] = useState(0.00)
    return (
        <td style={{ width: parseInt(r.strColWidth) }}>
            <Row className="mb-3">
                <Col md="12">
                    <DPTextBoxforgrid
                        rowClass="mb-12-sm"
                        labelText="Code"
                        textType="text"
                        textAlign="right"
                        maxLength={r.strColLen}
                        id={r.strColTblName + Key}
                        value={desc}
                        disabled={false}
                        onChange={e => {
                            setdesc(e.target.value)
                        }}
                        onBlur={e => {
                            let val = e.target.value.length > 1 ? (parseFloat(e.target.value) != NaN ? parseFloat(e.target.value) : 0.00) : e.target.value
                            console.log(val)
                            setdesc(isNaN(val) ? 0.00 : val)
                        }}
                    /*onKeyPress={e => {
                        KeyPressEvnt(e)
                    }}*/
                    ></DPTextBoxforgrid>
                </Col>
            </Row>
        </td >
    );
}
export const DateDetColumn = ({
    r,
    Key
}) => {
    const [desc, setdesc] = useState('')
    return (
        <td style={{ width: parseInt(r.strColWidth) }}>
            <Row className="mb-3">
                <Col md="12">
                    <DPTextBoxforgrid
                        rowClass="mb-12-sm"
                        labelText=""
                        textType="date"
                        //maxLength={r.strColLen}
                        id={r.strColTblName + Key}
                        value={desc}
                        disabled={false}
                        onChange={e => {
                            setdesc(e.target.value)
                        }}
                        onBlur={e => {
                            let val = e.target.value.length > 1 ? (parseFloat(e.target.value) != NaN ? parseFloat(e.target.value) : 0.00) : e.target.value
                            console.log(val)
                            setdesc(isNaN(val) ? 0.00 : val)
                        }}
                    /*onKeyPress={e => {
                        KeyPressEvnt(e)
                    }}*/
                    ></DPTextBoxforgrid>
                </Col>
            </Row>
        </td >
    );
}

export const TXNLineDetails = (props) => {

    function handleRowChanges(elementvalue, Row, key) {


        const updatedArray = props.TaxLineRemarks.map(item => {
            if (item.LineNo == props.LineNo && item.key == key) {
                return { ...item, remark: elementvalue };
            }
            return item;
        });


        props.SetTaxLineRemarks(updatedArray)
    }

    function RemoveLine(key, LineNo) {

        const RemarksNotInThisRow = props.TaxLineRemarks.filter((item) => item.LineNo != LineNo)

        const RemarksInThisRow = props.TaxLineRemarks.filter((item) => item.LineNo == LineNo)

        const filteredLines = RemarksInThisRow.filter((item) => item.key != key)

        var newLine = []

        filteredLines.map((item, index) => {
            var row = item
            row.key = index
            newLine.push(row)
        })

        const FinalRemarks = [...RemarksNotInThisRow, ...newLine]

        props.SetTaxLineRemarks(FinalRemarks)
    }

    function AddNewRemarkRow() {
        var newRemark = [...props.TaxLineRemarks, { LineNo: props.LineNo, key: 0, remark: "" }]
        props.SetTaxLineRemarks(newRemark)
    }

    return (
        <div>
            <Modal
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{props.SubTitle} </CardTitle>
                                    <p className="card-title-desc">
                                        {props.Details}
                                    </p>
                                    <Row>
                                        <Col sm={12} md={12} className="mb-12-sm">
                                            <table style={{ fontSize: "11px" }} id={"tblLineRemDet"}>
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>#</th>
                                                        <th style={{ textAlign: "left" }}>Remarks</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {props.DetailRemarks.map((formRow, key) => (
                                                        <TableRemRow
                                                            FormRow={formRow}
                                                            Key={key}
                                                            RemoveRow={props.RemoveRow}
                                                            Disabled={props.blDiasableGrid}
                                                            DetailRemarks={props.DetailRemarks}
                                                            SetRemLine={props.setDetailRemarks}
                                                            ProCode={props.SubTitle}
                                                            SetRemTbl={props.SetRemTbl}
                                                            DataRow={props.DataRow}
                                                            LineNo={props.LineNo}
                                                            disabled={props.disabled}
                                                            RemoveRemDetRow={RemoveLine}
                                                            handleRowChanges={handleRowChanges}
                                                            filteredLines={props.DetailRemarks}
                                                            TaxLineRemarks={props.TaxLineRemarks}
                                                            SetTaxLineRemarks={props.SetTaxLineRemarks}
                                                        />
                                                    ))}
                                                </tbody>
                                            </table>
                                        </Col>
                                        <Col sm={12} md={12} className="mb-12-sm">
                                            {props.DetailRemarks.length == 0 ? <Button
                                                onClick={() => {
                                                    AddNewRemarkRow()
                                                }}
                                                disabled={props.disabled}
                                                color="success"
                                                className="mt-1"
                                                id="DETADDNEW123"
                                            >AddNew</Button> : null}
                                        </Col>

                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </Modal>

        </div>
    );
}

const TableRemRow = ({ FormRow, Key, DetailRemarks,  ProCode, SetRemTbl, DataRow, LineNo, disabled, RemoveRemDetRow, handleRowChanges, filteredLines, TaxLineRemarks, SetTaxLineRemarks }) => {

    const KeyPressEvt = (e) => {
        if (e.charCode == 13) {

            const LinesForThisRow = TaxLineRemarks.filter((item) => item.LineNo == LineNo)
            const emptyRow = LinesForThisRow.findIndex(x => x.remark == "" || x.remark == null)


            if (emptyRow == -1) {
                let objTempRemData = [...filteredLines]

                objTempRemData.push({ LineNo: LineNo, key: filteredLines.length, remark: "" })

                const Lines = TaxLineRemarks.filter((item) => item.LineNo != LineNo) //get all lines except this lines in this line no

                const finalRemarks = [...Lines, ...objTempRemData]

                SetTaxLineRemarks(finalRemarks)

                setTimeout(() => {
                    document.getElementById("txtLineRemarks" + (filteredLines.length)).focus()
                }, 100)
            } else {

                document.getElementById("txtLineRemarks" + LinesForThisRow[emptyRow].key).focus()
            }
        }
    }

    //how to find object using index



    return (
        <tr key={FormRow.id}>
            <td style={{ width: "50px" }}>
                <Row className="mb-3" style={{ marginLeft: '2px' }}>
                    {Key + 1}
                </Row>
            </td>
            <td style={{ width: "400px" }}>
                <Row className="mb-3">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            disabled={disabled}
                            textAlign="left"
                            id={"txtLineRemarks" + FormRow.key}
                            value={FormRow.remark}
                            onChange={(e) => {
                                handleRowChanges(e.target.value, FormRow, FormRow.key)
                            }}
                            onKeyPress={(e) => { KeyPressEvt(e) }}
                        ></DPTextBoxforgrid>

                    </Col>
                </Row>
            </td>
            <td>
                <Row className="mb-3">
                    <Col md="1">
                        <Button
                            outline
                            disabled={disabled}
                            color="danger"
                            onClick={e => {
                                RemoveRemDetRow(FormRow.key, LineNo)
                            }}
                            size="sm"
                        >
                            <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
                        </Button>
                    </Col>
                </Row>
            </td>
        </tr>
    )
}
